import React, { FC } from 'react';
import cn from 'classnames';

import { useRiskFactorBarStyle } from './RiskFactorBar.style';

import { useGetRiskLevel } from '@/shared/hooks/useGetRiskLevel';
import { Agreement } from '@/shared/api/borrow';

export type RiskFactorBarProps = {
    agreement: Agreement;
    health: string | null;
};

export const RiskFactorBar: FC<RiskFactorBarProps> = ({ health, agreement }) => {
    const classes = useRiskFactorBarStyle();

    const { isHigh, isWarning, isLow } = useGetRiskLevel({
        health,
        marginCallThreshold: agreement.marginCallThreshold,
        liquidationThreshold: agreement.liquidationThreshold,
    });

    const PIVOT_HIGH_RISK = Number(agreement.liquidationThreshold);

    return (
        <div className={classes.placeholderBarWrapper}>
            <>
                <div className={classes.barWrapper}>
                    <div>Low</div>
                    <div
                        className={cn(classes.emptyBar, {
                            [classes.errorBar]: isHigh,
                            [classes.warningBar]: isWarning,
                            [classes.successBar]: isLow,
                        })}
                    >
                        <input
                            className={classes.slider}
                            type='range'
                            min='0'
                            max={PIVOT_HIGH_RISK}
                            defaultValue={health || '0'}
                            step='0.1'
                        />
                    </div>
                    <div>High</div>
                </div>
            </>
        </div>
    );
};
